// extracted by mini-css-extract-plugin
export default {"frame":"frame-module--frame--2XDBr","cover":"frame-module--cover--3Mofc","frameMedia":"frame-module--frame-media--3U4dw","contain":"frame-module--contain--35Ctv"};